import { getContainer, getStyles } from './utils';
import { asyncComponentOnReady } from '../../../globals/utils/helpers';
export default class NotificationBannerController {
  constructor(duration) {
    this.duration = duration;
    this.timeoutId = null;
    this.handleDidClose = (event) => {
      const target = event.target;
      target.remove();
      this.bannerElement = null;
      this.killTimeout();
    };
    this.handleCloseClick = (event) => {
      event.target.active = false;
    };
  }
  startTimeout() {
    if (!this.duration) {
      return;
    }
    this.timeoutId = window.setTimeout(() => {
      if (this.bannerElement) {
        this.bannerElement.active = false;
      }
    }, this.duration);
  }
  killTimeout() {
    if (!this.timeoutId) {
      return;
    }
    clearTimeout(this.timeoutId);
    this.timeoutId = null;
  }
  getBannerElement() {
    return this.bannerElement;
  }
  async show(opts) {
    if (this.bannerElement) {
      return this.showAfter(this.bannerElement, opts);
    }
    if (this.createPromise) {
      return this.showAfter(await this.createPromise, opts);
    }
    this.createPromise = this.create(opts);
    this.bannerElement = await this.createPromise;
    this.createPromise = null;
    return this.bannerElement;
  }
  async showAfter(element, opts) {
    await this.close(element);
    return this.show(opts);
  }
  async close(element) {
    element.active = false;
    return new Promise((resolve) => {
      element.addEventListener('didClose', resolve);
    });
  }
  async create({ target = 'header', componentProps }) {
    const element = document.createElement('pes-notification-banner');
    element.dir = document.documentElement.dir || 'auto';
    const container = getContainer(target);
    container.appendChild(element);
    const fixTarget = container === document.body ? 'body' : target;
    Object.assign(element, getStyles(fixTarget), componentProps);
    element.addEventListener('closeDidClick', this.handleCloseClick);
    element.addEventListener('didClose', this.handleDidClose);
    this.bannerElement = await asyncComponentOnReady(element);
    this.startTimeout();
    return this.bannerElement;
  }
}
